import axios from 'axios';
import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

const fetcher = async () => {
  const source = axios.CancelToken.source();

  const promise = request.get(
    '/Request/filter_date_modes',
    undefined,
    undefined,
    'Error',
    undefined,
    undefined,
    { cancelToken: source.token },
    true
  );

  promise.cancel = () => {
    source.cancel();
  };

  return promise;
};

const useRequestsDateModes = (options) =>
  useQuery(queryKeys.requestDateModes(), fetcher, {
    staleTime: Infinity,
    ...options,
  });

export default useRequestsDateModes;
